import { plainToClass } from "class-transformer"

export type ClassConstructor<T> = new (...args: any[]) => T
export abstract class Mapper<S, T> {
	constructor(private readonly targetClass?: ClassConstructor<T>) {}

	Map(source: S): T {
		// Create target instance using plainToClass
		if (!this.targetClass) {
			// if no target class passed in then just return custom mapping
			return this.customMapping(source, null as any)
		}
		const baseTarget = plainToClass(this.targetClass, source)

		// Allow subclasses to customize the mapping
		return this.customMapping(source, baseTarget)
	}

	protected customMapping(source: S, target: T): T {
		// Default implementation just returns the plainToClass result
		return target
	}

	// Array mapping
	MapArray(sources: S[]): T[] {
		if (!sources) return []
		return sources.Map((source) => this.Map(source))
	}
}
